<template>
  <div>
    <Pagination :total="listTotal" :curPage="pageIndex" :pageSize="params.pageSize" @clickPage="clickPage"
      v-if="listTotal > 0" />
    <div class="items" v-for="(item, index) in dataList" :key="index">
      <div class="tit">
        <a :href="`/#/program/${item.id}/yzF18x8zmN`" target="_blank">{{item.id}}: {{ item.name }}</a>
      </div>
      <div class="imgList flex wrap">
        <div class="imgItem" v-for="(v, i) in item.list" :key="i">
          <a :href="v" target="_blank"><img :src="v"></a>
        </div>
      </div>
    </div>
    <Pagination :total="listTotal" :curPage="pageIndex" :pageSize="params.pageSize" @clickPage="clickPage"
      v-if="listTotal > 0" />
  </div>
</template>

<script>
import Pagination from '@/components/pagination.vue'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      pageIndex: 1,
      params: {
        pageSize: 50,
        subtype_id: -1,
        brand_id: -1,
        activity_id: -1,
        is_top: -1,
        is_award: -1,
        level: -1,
        city: '',
        task_year: '',
        keywords: '',
        channel_ids: '',
        showtype: '',
        programform: '',
        award: '',
        type_tag: '',
        recommend: -1,
        user_id: 0,
      },
      dataList: [],
      listTotal: 0,
    }
  },
  created() {
    this.initPage()
  },
  methods: {
    //跳转分页
    clickPage(info) {
      if (info.topage > 0) {
        this.pageIndex = info.topage;
        this.getList()
      }
    },
    initPage() {
      this.getList()
    },
    async getList() {
      const params = {
        ...this.params,
        page: this.pageIndex
      }
      const res = await this.$api.jmkApi.getList(params)
      let list = res.data || []
      this.listTotal = res.total;
      this.dataList = []
      if (list && list.length > 0) {
        list.map(async (v) => {
            const obj = {
              id: v.id,
              name: v.name,
              list: []
            }
            const resDetail = await this.$api.jmkApi.getOneById({
              id: v.id,
              no_access: 1
            })
            const dt = resDetail.data || {}
            if (dt.cover_img || dt.pic_list) {
              if (dt.cover_img) {
                obj.list.push(resDetail.showpath + dt.cover_img)
              }
              if (dt.pic_list) {
                const picList = dt.pic_list.split(',')
                picList.map((v) => {
                  obj.list.push(resDetail.showpath + v)
                })
              }
            }
            this.dataList.push(obj)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.items {
  padding: 20px;
  .tit {
    font-size: 16px;
    background-color: #666;
    padding: 5px 10px;
    margin-bottom: 10px;
    cursor: pointer;
    a {
      color: #FFF;
    }
    &:hover {
      opacity: .8;
    }
  }
  .imgList {
    .imgItem {
      flex-shrink: 1;
      width: 250px;
      margin: 0 5px 10px;;
      border: 1px solid #ccc;
      img {
        display: block;
        max-width: 100%;
        max-height: 300px;
        margin: 0 auto;
      }
    }
  }
}
</style>